import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import object from "./navBar.json";
import "./NavBarItem.css";
const NavBarItem = () => {
  const handleHome = (event) => {
    event.preventDefault();
    window.location.replace("/");
  };
  return (
    <div className="navbar">
      <div className="navbar-head">
        <p className="name-web" onClick={handleHome}>
          Booking Website
        </p>
        <div className="navbar-buttons">
          <button className="navbar-button">Register</button>
          <button className="navbar-button">Login</button>
        </div>
      </div>
      <div className="navbar-links">
        {object.map((item, index) => (
          <div
            key={index}
            className={`navbar-link ${item.active ? "active" : ""}`}
          >
            <FontAwesomeIcon className="navbar-icon" icon={item.icon} />
            <span>{item.type}</span>{" "}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NavBarItem;
